import src from "IMAGE";
export default { src, width: 181, height: 180, blurWidth: 0, blurHeight: 0};
